// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1jZ2h","alert":"SettungsInbox_alert__CjFfb"};